import useCommentDraftSession from "./use-comment-draft-session";
import useStandCommentsApi from "./use-stand-comments-api";
import useCommentModal from "./use-comment-modal";

const CommentsHooks = {
    useDraftSession: useCommentDraftSession,
    useApi: useStandCommentsApi,
    useCommentModal
};

export default CommentsHooks;
